import apiClient from './apiClient';

// Equipment Data with Pending Changes
export const fetchEquipmentWithPendingChanges = async (customerId) => {
    try {
        const response = await apiClient.get(`/api/customers/${customerId}/equipment`);
        return response.data;
    } catch (error) {
        console.error('Error fetching equipment data:', error);
        throw error;
    }
};

// Store Pending Changes
export const storePendingParentChange = async (customerId, changeData) => {
    try {
        const response = await apiClient.post(`/api/customers/${customerId}/equipment/pending-changes/parent`, changeData);
        return response.data;
    } catch (error) {
        console.error('Error storing pending parent change:', error);
        throw error;
    }
};

export const storePendingChildChange = async (customerId, changeData) => {
    try {
        const response = await apiClient.post(`/api/customers/${customerId}/equipment/pending-changes/child`, changeData);
        return response.data;
    } catch (error) {
        console.error('Error storing pending child change:', error);
        throw error;
    }
};

// Store New Equipment Creation Requests
export const storePendingParentCreation = async (customerId, newData, changedBy) => {
    try {
        const response = await apiClient.post(`/api/customers/${customerId}/equipment/pending-changes/create-parent`, {
            newData,
            changedBy,
            changeAction: 'create'
        });
        return response.data;
    } catch (error) {
        console.error('Error storing pending parent creation:', error);
        throw error;
    }
};

export const storePendingChildCreation = async (customerId, parentEqpId, newData, changedBy) => {
    try {
        const response = await apiClient.post(`/api/customers/${customerId}/equipment/pending-changes/create-child`, {
            parentEqpId,
            newData,
            changedBy,
            changeAction: 'create'
        });
        return response.data;
    } catch (error) {
        console.error('Error storing pending child creation:', error);
        throw error;
    }
};

// Admin Review Functions
export const fetchPendingChanges = async (customerId) => {
    try {
        const response = await apiClient.get(`/api/customers/${customerId}/equipment/pending-changes`);
        return response.data;
    } catch (error) {
        console.error('Error fetching pending changes:', error);
        throw error;
    }
};

export const fetchPendingCreations = async (customerId) => {
    try {
        const response = await apiClient.get(`/api/customers/${customerId}/equipment/pending-changes/creations`);
        return response.data;
    } catch (error) {
        console.error('Error fetching pending creations:', error);
        throw error;
    }
};

export const approveChange = async (customerId, changeId) => {
    try {
        const response = await apiClient.patch(`/api/customers/${customerId}/equipment/pending-changes/${changeId}/approve`);
        return response.data;
    } catch (error) {
        console.error('Error approving change:', error);
        throw error;
    }
};

export const rejectChange = async (customerId, changeId, rejectionReason) => {
    try {
        const response = await apiClient.patch(`/api/customers/${customerId}/equipment/pending-changes/${changeId}/reject`, {
            rejectionReason
        });
        return response.data;
    } catch (error) {
        console.error('Error rejecting change:', error);
        throw error;
    }
};

// Backend Confirmation
export const confirmBackendWork = async (customerId) => {
    try {
        const response = await apiClient.post(`/api/customers/${customerId}/equipment/confirm-backend-work`);
        return response.data;
    } catch (error) {
        console.error('Error confirming backend work:', error);
        throw error;
    }
};

// Fetch Equipment Policies
export const fetchEquipmentPolicies = async (customerId) => {
    try {
        const response = await apiClient.get(`/api/customers/${customerId}/equipment/policies`);
        return response.data;
    } catch (error) {
        console.error('Error fetching equipment policies:', error);
        throw error;
    }
};

// Store Pending Policy Change
export const storePendingPolicyChange = async (customerId, changeData) => {
    try {
        console.log('API Call - storePendingPolicyChange:', {
            url: `/api/customers/${customerId}/equipment/policies/pending-changes`,
            payload: changeData
        });
        const response = await apiClient.post(`/api/customers/${customerId}/equipment/policies/pending-changes`, changeData);
        return response.data;
    } catch (error) {
        console.error('Error storing pending policy change:', error);
        console.error('Error response:', error.response?.data);
        console.error('Request payload was:', changeData);
        throw error;
    }
};

// Store New Policy Creation Request
export const storePendingPolicyCreation = async (customerId, newData) => {
    try {
        const response = await apiClient.post(`/api/customers/${customerId}/equipment/policies/pending-changes/create`, {
            newData,
            changeAction: 'create'
        });
        return response.data;
    } catch (error) {
        console.error('Error storing pending policy creation:', error);
        throw error;
    }
};

// Fetch Pending Policy Changes
export const fetchPendingPolicyChanges = async (customerId) => {
    try {
        const response = await apiClient.get(`/api/customers/${customerId}/equipment/policies/pending-changes`);
        return response.data;
    } catch (error) {
        console.error('Error fetching pending policy changes:', error);
        throw error;
    }
};

// Approve Pending Policy Change
export const approvePolicyChange = async (customerId, changeId) => {
    try {
        const response = await apiClient.patch(`/api/customers/${customerId}/equipment/policies/pending-changes/${changeId}/approve`);
        return response.data;
    } catch (error) {
        console.error('Error approving policy change:', error);
        throw error;
    }
};

// Reject Pending Policy Change
export const rejectPolicyChange = async (customerId, changeId, rejectionReason) => {
    try {
        const response = await apiClient.patch(`/api/customers/${customerId}/equipment/policies/pending-changes/${changeId}/reject`, {
            rejectionReason
        });
        return response.data;
    } catch (error) {
        console.error('Error rejecting policy change:', error);
        throw error;
    }
};

// Helper function to create change data structure
export const createChangeData = (originalData, modifiedData, changedBy, changeAction = 'update') => {
    return {
        originalData,
        modifiedData,
        changedBy,
        changeAction,
        changedAt: new Date().toISOString()
    };
};
